import { GzInventoryItemWebComponent } from './component/GzInventoryItemWebComponent';

export { GzInventoryItemWebComponent };
